import { render } from "./HelpcategoryModal.vue?vue&type=template&id=2a796af6"
import script from "./HelpcategoryModal.vue?vue&type=script&lang=js"
export * from "./HelpcategoryModal.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__